import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InsuranceClaimApiService } from './insurance-claim.api.service';
import { InsuranceClaimEffects } from './insurance-claim.effects';
import {
  insuranceClaimReducer,
  insuranceClaimInitialState,
  IInsuranceClaimState,
} from './insurance-claim.reducer';
import { InsuranceClaimService } from './insurance-claim.service';
import { insuranceClaimFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IInsuranceClaimState>(
      insuranceClaimFeatureKey,
      insuranceClaimReducer,
      {
        initialState: insuranceClaimInitialState,
      },
    ),
    EffectsModule.forFeature([InsuranceClaimEffects]),
  ],
  providers: [InsuranceClaimApiService, InsuranceClaimService],
})
export class StoreInsuranceClaimModule {}
